import React, { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { Breadcrumb } from '~/components/Breadcrumps';
import { Button } from '~/components/Button';
import { DetailsView } from '~/components/DetailsView';
import { onSubmitError } from '~/components/Form';
import { Title } from '~/components/Title';
import { EditorInput } from '~/components/Controls/Editor';
import { useModals } from '~/components/Modal';
import { BreadcrumbsResourcePage } from '~/components/ResourcePage';
import { useAbility } from '~/lib/ability';
import { useDataSource } from '~/lib/dataSource';
import { ResourceLoader, useResource } from '~/lib/loader';
import { pmpLinks } from '~/modules/Pmp';
import { SupplyPackagesAbility } from '~/modules/Pmp/ability';
import { supplyPackagesAdapter } from '~/modules/Pmp/adapters';
import { SupplyPackageForm } from '~/modules/Pmp/forms/supplyPackageForm';
import { fetchSupplyPackage } from '~/modules/Pmp/api'

interface ISupplyPackageViewParams {
    supplyPackageId: string;
}

export const SupplyPackageView = () => {
    const ability = useAbility(SupplyPackagesAbility);
    let { fetchRecords, updateRecord } = useDataSource(supplyPackagesAdapter);
    useEffect(() => fetchRecords(), []);
    const modals = useModals();
    const params = useParams<ISupplyPackageViewParams>();
    const supplyPackageResult = useResource(() => fetchSupplyPackage(params.supplyPackageId));

    const editSupplyPackage = modals.create(SupplyPackageForm, {
        onSubmit: (updatedSupplyPackage, formikActions, close) => {
            updateRecord(updatedSupplyPackage).then(supplyPackageResult.setResource).then(close).catch(onSubmitError(formikActions));
        }
    });

    return <ResourceLoader result={supplyPackageResult} message='Loading supplyPackage'>
        {({ resource: supplyPackage, isPending }) =>
            <Breadcrumb breadcrumb={{
                to: pmpLinks.supplyPackages(),
                title: 'Supply Packages'
            }}><Breadcrumb breadcrumb={{
                to: pmpLinks.supplyPackage(supplyPackage.id),
                title: supplyPackage.name
            }}>
                    <BreadcrumbsResourcePage title={supplyPackage.name} toolbar={ability.canEdit() && <Button responsive
                        key='edit'
                        disabled={isPending}
                        leftIcon={<i
                            className='fa fa-edit' />}
                        onClick={() => editSupplyPackage.show({ supplyPackage })}>
                        Edit
                    </Button>}>
                        <DetailsView fields={[
                            { label: 'Id', value: supplyPackage.id },
                            { label: 'Description', value: supplyPackage.description },
                            { label: 'Name', value: supplyPackage.name },
                        ]} />
                        <Title>Rules</Title>
                        <EditorInput
                            mode='text'
                            minLines={2}
                            maxLines={50}
                            disabled
                            value={supplyPackage.rules || ''} />
                    </BreadcrumbsResourcePage>

                </Breadcrumb>
            </Breadcrumb>}
    </ResourceLoader>;
};
